<template>
  <div class="additional-data">
     <div class="row">
      <div class="col-sm-12 col-lg-4 form-group" style="margin-bottom: 0px">
        <Toggle
          :notToggledText="$t('common.no')"
          :toggledText="$t('common.yes')"
          :toggleText="$t('stock_management.contracts_purchase_sale.overwrite_delivery_note_quantity')"
          :isActive="!!localData.overwrite_delivery_note_quantity"
          :onChange="handleToggleOverwriteDeliveryNoteQuantity"
        ></Toggle>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-12 col-lg-5 text-left">
        <label class="control-label">{{ $t("stock_management.contracts_purchase_sale.contract_details") }}</label>
        <DxTextArea
          v-model="localData.contract_details"
          placeholder=""
          :height="60"
          :rows="2"
          :cols="50"
          :maxLength="250"
          :showClearButton="true"
        ></DxTextArea>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-12 col-lg-5 text-left">
        <label class="control-label">{{ $t("remark") }}</label>
        <DxTextArea
          v-model="localData.notes"
          placeholder=""
          :height="90"
          :rows="3"
          :cols="50"
          :maxLength="400"
          :showClearButton="true"
        ></DxTextArea>
      </div>
    </div>
  </div>
</template>

<script>
import DxTextArea from "devextreme-vue/text-area";
import Toggle from "@/components/Toggle.vue";

export default {
  name: "additionalData",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData }, // Create a local copy of formData
    };
  },
  computed: {},
  components: {
    DxTextArea,
    Toggle,
  },
  methods: {
    validate() {
      return [];
    },
    updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        //console.log("updateData step 4 ", newData);
        this.localData = { ...newData }; // Update localData with new data
      }
    },
    handleToggleOverwriteDeliveryNoteQuantity(isActive) {
      this.localData.overwrite_delivery_note_quantity = isActive ? 1 : 0; // Update localData with overwrite_delivery_note_quantity status
    },
  },
  watch: {
    formData: {
      deep: true,
      handler(newData) {
        if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
          this.localData = { ...newData };
        }
      },
    },
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("input", newData);
        this.$emit("update-form-data", newData, 4); // Emit updated data to parent
      },
    },
  },
};
</script>

<style scoped>
.additional-data {
  height: 100%;
  width: 100%;
}
</style>
